const europeanCapitals = [
    'Amsterdam',
    'Andorra',
    'Athens',
    'Belgrade',
    'Berlin',
    'Bern',
    'Bratislava',
    'Brussels',
    'Bucharest',
    'Budapest',
    'Chisinau',
    'Copenhagen',
    'Dublin',
    'Helsinki',
    'Kiev',
    'Lisbon',
    'Ljubljana',
    'London',
    'Luxembourg',
    'Madrid',
    'Minsk',
    'Monaco',
    'Moscow',
    'Nicosia',
    'Nuuk',
    'Oslo',
    'Paris',
    'Podgorica',
    'Prague',
    'Reykjavik',
    'Riga',
    'Rome',
    'San Marino',
    'Sarajevo',
    'Skopje',
    'Sofia',
    'Stockholm',
    'Tallinn',
    'Tirana',
    'Vaduz',
    'Valletta',
    'Vatican City',
    'Vienna',
    'Vilnius',
    'Warsaw',
    'Zagreb'
]

export function getRandomCapital() {
    return europeanCapitals[Math.floor(Math.random() * europeanCapitals.length)];
}
